<template>
  <div class="header-container container container-xxl">
    <div class="header-wrap">
      <div class="header-logo logo animated" data-animate="fadeInDown" data-delay=".6">
        <a href="/" class="logo-link">
          <img class="logo-dark" src="/static/images/custom/quBit-logo.png" srcset="/static/images/custom/quBit-logo.png 2x" alt="logo">   
          <img class="logo-light" src="/static/images/custom/quBit-logo.png" srcset="/static/images/custom/quBit-logo.png 2x" alt="logo">     
        </a>
      </div>
      <div class="header-nav-toggle" @click="toggleNav">
        <a href="#" class="navbar-toggle" :class="{'navbar-active': displayNav}">
          <div class="toggle-line"><span></span></div>   
        </a>
      </div>
      <div class="header-navbar animated" :class="{'menu-mobile': displayNav, 'menu-shown': displayNav}">
        <nav class="header-menu" id="header-menu">
          <ul class="menu">
            <li class="menu-item">
              <a class="" href="/#about">About<span class="sr-only">(current)</span></a>         
            </li>
            <li class="menu-item">
              <a class="" href="/#features">Features</a>     
            </li>
            <li class="menu-item">
              <a class="nav-link menu-link" href="/#why">Why NIPOST ESTAMP</a>    
            </li>
            <li class="menu-item">
              <a class="nav-link menu-link" href="/#buy">Buy Stamp</a>       
            </li>
            <li class="menu-item">
              <a class="nav-link menu-link" href="/#faqs">Faqs</a>    
            </li>
            <li class="menu-item">
              <a class="nav-link menu-link" href="/#contact">Contact</a>      
            </li>
          </ul>
          <ul class="menu-btns">
            <li>
              <a href="https://dance.qubit.ng/auth/login" target="_blank" class="btn btn-sm btn-thin btn-outline btn-auto">  
                <span>Login</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      displayNav: false
    }
  },
  methods: {
    toggleNav () {
      setTimeout(() => {
        this.displayNav = !this.displayNav
      }, 0);
    }
  }
}
</script>

<style>

</style>
